import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  login: (username, password) => api.post('/auth/login', { username, password }),
  register: (username, email, password) => api.post('/auth/register', { username, email, password }),
};

// Tracks API
export const tracksAPI = {
  getAll: (params) => api.get('/tracks', { params }),
  getById: (id) => api.get(`/tracks/${id}`),
  upload: (formData) => api.post('/tracks', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  update: (id, data) => api.put(`/tracks/${id}`, data),
  delete: (id) => api.delete(`/tracks/${id}`),
  search: (term) => api.get('/tracks', { params: { search: term } }),
  block: (id) => api.patch(`/tracks/${id}/block`),
  unblock: (id) => api.patch(`/tracks/${id}/unblock`),
};

// Streaming API
export const streamingAPI = {
  getNowPlaying: () => axios.get('/now-playing'),
  getStreamUrl: () => '/stream',
};

// Schedules API
export const schedulesAPI = {
  getCurrent: () => api.get('/schedules/current'),
  getAll: () => api.get('/schedules'),
};

// TTS API
export const ttsAPI = {
  getQueue: () => api.get('/tts/queue'),
  getSettings: () => api.get('/tts/settings'),
  updateSettings: (ttsBetweenTracksEnabled) => api.put('/tts/settings', { ttsBetweenTracksEnabled }),
};

// News API
export const newsAPI = {
  fetch: () => api.get('/news/fetch'),
  broadcast: (articles) => api.post('/news/broadcast', articles ? { articles } : {}),
};

// Weather API
export const weatherAPI = {
  fetch: () => api.get('/weather/fetch'),
  broadcast: (weatherData) => api.post('/weather/broadcast', weatherData ? { weatherData } : {}),
};

// AI API
export const aiAPI = {
  generateMusicPrompt: () => api.post('/ai/generate-music-prompt'),
};

export default api;
